<template>
  <div class="access-process">
    <h1>Access Process</h1>
    <p>{{ data.firstname }}</p>
    <p>{{ data.error }}</p>
    <p>{{ statusMessage }}</p>
    <p>{{ authMessage }}</p>
    <div v-if="statusMessage == '200'">  
      <p> Zostałeś pomyślnie zalogowany <br>
      <router-link to="/home">przejdź</router-link> do serwisu
    </p> 
    </div>
  </div>  
</template>

<script>
    import authService from "@/services/auth.js";
    import { useConfigStore } from "@/store/config";

    export default {
        name: "AccessProcessComponent",
        data() {
            return {
                post: "grant_type=password&uuid=" + this.$route.params.Uid,
                data: {},
                statusMessage: '',
                authMessage: ''
            };
        },
        created() {

            console.log("AccessProcess - created!");

            this.data = {};
            this.createAccess();

        },
        methods: {

            async createAccess() {

                console.log("createAccess - post");
                console.log(this.post);

                try {

                    const postData = await authService.createAccessPost(this.post);

                
                    this.data = await postData.json();
                    this.statusMessage = postData.status;

                    console.log("statusMessage");
                    console.log(this.statusMessage);
                    //this.data = postData;

                    // console.log('createAccess-this.data');
                    // console.log(this.data);

                    // console.log('postData.ok');
                    // console.log(postData.ok);
                    // console.log('this.statusMessage');
                    // console.log(this.statusMessage);

                    if (!postData.ok) {
                        const error = (postData && postData.message) || postData.status;
                        this.data.error = error;
                        return Promise.reject(error);
                    }

                    if (this.statusMessage == '200') {                            

                            const authStore = useConfigStore(); 
                            authStore.login(
                                {userID: this.data.uid, 
                                 userFirstName: this.data.firstname, 
                                 userLastName: this.data.lastname
                                }, 
                                this.data.access_token); 

                            this.$router.push({name: "Home"});
                    }


                } catch (err) {
                    this.statusMessage = err.message || "Ups coś poszło nie tak!";
                }


                    const auth = useConfigStore();
                    console.log(auth.userID);
                    console.log(auth.userFirstName);
                    console.log(auth.userLastName);
                    console.log(auth.token);


                },
           
        }
    }

</script>

<style scoped>
    .access-process {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .access-process h1 {
    margin: 40px 0 0;
    color: var(--blue-dark);
    font-size: 28px;
    }

    .access-process p {
        margin: 10px 0;
        text-align: center;
    }

    .access-process a {
        margin: 10px 0;
        color: var(--purple);
    }



</style>